import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HomeSecretaria.scss";

import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";

import SecretariaBottomContainers from "./components/SecretariaBottomContainers";
import MarcacoesSecretaria from "./components/marcacoesSecretaria/MarcacoesSecretaria";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import Tasks from "../components/tasks/Tasks";
import PdfListaAtendimentos from "../../../shared/components/PdfGenerator/PdfListaAtendimentos/PdfListaAtendimentos";

import "../components/top5tratamentos/Top5tratamentos.scss";
import "../../../shared/css/Checkbox.scss";
import MarcacoesTratamentoSecretaria from "./components/marcacoesSecretaria/MarcacoesTratamentoSecretaria";
// import ProcedimentosExecutadosHoje from "../components/procedimentosExecutadosHoje/ProcedimentosExecutadosHoje";
// import ConnectWhatsAppButton from "../../../shared/components/connectWhatsappAppButton/ConnectWhatsAppButton";

const DAILY_MESSAGES = [
  "Que o telefone toque só com boas notícias e pacientes simpáticos!",
  "Hoje o café é teu aliado e o sistema, teu campo de batalha!",
  "Organizar agenda é arte — e tu és o Picasso do Excel!",
  "Que o dia comece calmo e termine com tudo confirmado!",
  "Se o sistema travar, respira: nem o computador entende o stress da receção!",
  "Hoje é dia de transformar confusão em coordenação!",
  "Que tua paciência dure mais que fila de espera!",
  "O segredo do sucesso? Um sorriso na receção e um café por perto!",
  "Lembra: a primeira impressão do paciente é sempre o teu sorriso!",
  "Hoje a meta é simples: agendar tudo, perder nada e manter a calma!",
  "Que o Wi-Fi coopere e o paciente não esqueça o horário!",
  "Gerir clínica é fácil — disse ninguém nunca!",
  "Hoje o foco é brilhar: nos emails, nos atendimentos e no humor!",
  "Que cada ligação traga boas notícias e nenhum cancelamento!",
  "Organização é teu superpoder — e o caos, teu inimigo natural!",
  "Hoje és o maestro da clínica — e todos tocam conforme tua agenda!",
  "Que os lembretes cheguem antes dos atrasos!",
  "Nada é impossível quando há planilha, paciência e café!",
  "Hoje é o dia de mostrar que bom atendimento também cura!",
  "Que teu dia seja mais leve que a caixa de entrada!",
  "Se o plano de saúde complicar, sorri: é só mais uma terça-feira!",
  "Que tua gestão inspire e teu humor contagie!",
  "Hoje és o escudo contra o caos — e o caos respeita sorriso firme!",
  "Que o dia renda tanto quanto mês com feriado e bônus!",
  "Nada como começar o dia sabendo que sem ti, nada anda!",
  "Que tua voz no telefone soe tão doce quanto confirmação de consulta!",
  "Hoje o mundo pode girar, mas a receção não pode parar!",
  "Lembra: secretária boa não se estressa — sincroniza com o universo!",
  "Que teu dia seja tão eficiente quanto teu olhar quando alguém bagunça a agenda!",
  "Organizar pessoas é difícil, mas tu fazes parecer fácil!",
  "Hoje é dia de sorrir, resolver e brilhar — tudo ao mesmo tempo!",
  "Hoje lembra: o segredo da boa gestão é café quente e paciência gelada!",
];

function HomeSecretaria() {
  const [refreshAgendamentos, setRefreshAgendamentos] = useState(0);
  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  const [dadosPdf, setDadosPdf] = useState({
    show: false,
    listaAtendimentoData: [],
    medico: "",
  });

  const navigate = useNavigate();

  const showSinglePage = () => {
    setDadosPdf({ show: false });
  };

  const verPdf = (
    medico,
    allMarcacoes,
    dataLista,
    incluirObservacoes,
    unidade,
  ) => {
    const filteredMarcacoes = [];
    allMarcacoes.forEach((mr) => {
      if (mr.medico._id === medico.id) {
        filteredMarcacoes.push({
          cliente: mr.nome,
          contacto: mr.contacto,
          procedimento: mr.avaliacao
            ? "Avaliação"
            : mr.tratamentoIsolado
              ? mr.tratamento
              : clinica.clinica.configuracoes.configuracoes.tipoAgendamento
                    .tipo === "Tratamento"
                ? mr.tratamento.designacao
                : mr.categoriaTratamento.categoria,
          data_inicio_execucao: mr.data_inicio_execucao,
          data_fim_execucao: mr.data_fim_execucao,
          observacoesAgendamento: mr.observacoesAgendamento,
        });
      }
    });

    setDadosPdf({
      show: true,
      listaAtendimentoData: filteredMarcacoes,
      medico: medico.nome,
      dataLista,
      incluirObservacoes: incluirObservacoes,
      // De que unidade é a lista. Vazio nas clínicas de unidade única.
      unidade,
    });
  };
  ///////////////////////////////////////////////////

  const onSuccessCriarAgendamentoProvisorio = () => {
    setRefreshAgendamentos((prev) => prev + 1);
  };

  return (
    <>
      {dadosPdf.show && (
        <PdfListaAtendimentos
          showPreviousPage={showSinglePage}
          medico={dadosPdf.medico}
          clinica={clinica.clinica.nome}
          unidade={dadosPdf.unidade}
          listaAtendimentoData={dadosPdf.listaAtendimentoData}
          dataLista={dadosPdf.dataLista}
          incluirObservacoes={dadosPdf.incluirObservacoes}
        />
      )}

      <div className="home">
        <Sidebar />
        <div className="homeContainer">
          <Navbar
            title="Dashboard"
            icon={DashboardIcon}
            onSuccessCriarAgendamentoProvisorio={
              onSuccessCriarAgendamentoProvisorio
            }
          />
          <div className="dashboard__secretaria__heading">
            <div className="dashboard__ola">
              <span className="dashboard__ola__big">{`Olá, ${auth.nomeAbreviado}!`}</span>
              <span className="dashboard__ola__small">
                {DAILY_MESSAGES[new Date().getDate() - 1] || ""}
              </span>
            </div>

            <div className="dashboard__secretaria__addCliente__container">
              <span
                className="blue-button blue-button__dashboard__secretaria"
                onClick={() => navigate("/clientes/new")}
              >
                Adicionar Cliente
              </span>
            </div>
          </div>
          {/* <ConnectWhatsAppButton/> */}

          <SecretariaBottomContainers
            refreshAgendamentos={refreshAgendamentos}
          />

          <div className="dashboard-administrativo__marcacoes caixa">
            {clinica.clinica.configuracoes.configuracoes.tipoAgendamento
              .tipo === "Tratamento" ? (
              <MarcacoesTratamentoSecretaria verPdf={verPdf} />
            ) : (
              <MarcacoesSecretaria verPdf={verPdf} />
            )}
          </div>

          {/* <div
            className="dashboard-administrativo__procedimentos-hoje caixa"
            style={{ marginTop: 20 }}
          >
            <ProcedimentosExecutadosHoje
              sendRequest={sendRequest}
              clinicaId={clinica.clinica._id}
              token={auth.token}
              dentistas={(auth.usuariosAssociados || [])
                .map((u) => u.id)
                .join(",")}
              refresh={refreshAgendamentos}
            />
          </div> */}

          <div className="dashboard__bottom caixa tasks__container">
            <Tasks sendRequest={sendRequest} clinica={clinica} auth={auth} />
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeSecretaria;
